import React from 'react';
import { View, TouchableOpacity } from 'react-native';

import { isNil as _isNil } from 'lodash';
import PropTypes from 'prop-types';

import { VFText, Icon } from '@vfgroup-oneplatform/foundation/Components';
import { LightThemeColors, withTheme } from '@vfgroup-oneplatform/foundation/Components/Themes';
import VFLottieView from '@vfgroup-oneplatform/foundation/Components/VFLottieView';

import styles from './PaymentCenterView.Styles';

const PaymentCenterView = ({
  title,
  titlePlaceHolders,
  subTitle,
  subTitlePlaceHolders,
  sourceImage,
  isPaymentRequest,
  isTick,
  isPaymentFailed,
  isReward,
  lottieID,
  titleID,
  subTitleID,
  theme,
  lottietype,
  isLoadingError,
  tryAgainIcon,
  onTryAgainPress,
  customTickLottie,
  isVoucherTopUpContainer,
  ...props
}) => {
  const paymentContainerStyle = isPaymentRequest && styles.paymentContainer;
  const rewardContainerStyle = isReward && styles.giftContainer;
  const tickContainerStyle = isTick && styles.tickContainer;
  const paymentFailedContainer = isPaymentFailed && styles.failedContainer;
  const paymentErrorContainer = isLoadingError && styles.paymentErrorContainer;
  const voucherCodeContainer = isVoucherTopUpContainer && styles.voucherCodeContainer;

  return (
    <View
      style={[
        styles.containerCenter,
        paymentContainerStyle,
        rewardContainerStyle,
        tickContainerStyle,
        paymentFailedContainer,
        paymentErrorContainer,
        voucherCodeContainer,
      ]}
    >
      {sourceImage && (
        <Icon name={sourceImage} type="image" style={styles.sourceImage(isLoadingError)} />
      )}
      {lottietype && (
        <VFLottieView
          autoPlay
          style={isReward ? styles.rewardLottieViewStyle : styles.lottieView(isPaymentRequest)}
          type={lottietype === 'tick' && !_isNil(customTickLottie) ? 'custom' : lottietype}
          source={customTickLottie}
          loop={!!isPaymentRequest}
          isReward
          testID={lottieID}
        />
      )}
      {title && (
        <View style={styles.headerContainer}>
          <VFText
            style={[styles.responseTitle(theme), isReward && styles.giftTitle]}
            i18nKey={title}
            testID={titleID}
            placeHolders={titlePlaceHolders}
          />
        </View>
      )}
      {subTitle && (
        <VFText
          style={[
            isPaymentRequest
              ? styles.paymentSubTitle(theme)
              : styles.subTitle(theme, isLoadingError),
            styles.alignCenter,
          ]}
          i18nKey={subTitle}
          testID={subTitleID}
          placeHolders={subTitlePlaceHolders}
        />
      )}
      {isLoadingError && (
        <TouchableOpacity
          style={styles.tryButton}
          onPress={() => onTryAgainPress()}
          accessible={false}
        >
          <VFText i18nKey={'top_up_quick_action_error_button'} style={styles.txtButton(theme)} />
          <Icon name={tryAgainIcon} type="image" size={26} style={styles.iconButton} />
        </TouchableOpacity>
      )}
    </View>
  );
};

PaymentCenterView.defaultProps = {
  isReward: false,
  theme: LightThemeColors,
};

PaymentCenterView.propTypes = {
  title: PropTypes.string,
  titlePlaceHolders: PropTypes.arrayOf(PropTypes.string),
  subTitle: PropTypes.string,
  subTitlePlaceHolders: PropTypes.arrayOf(PropTypes.any),
  sourceImage: PropTypes.object,
  isPaymentRequest: PropTypes.bool,
  isReward: PropTypes.bool,
  isTick: PropTypes.bool,
  isPaymentFailed: PropTypes.bool,
  lottieID: PropTypes.string,
  titleID: PropTypes.string,
  subTitleID: PropTypes.string,
  lottietype: PropTypes.string,
  theme: PropTypes.shape({
    name: PropTypes.string,
    isDark: PropTypes.bool,
    colors: PropTypes.object,
  }),
  isLoadingError: PropTypes.bool,
  tryAgainIcon: PropTypes.any,
  onTryAgainPress: PropTypes.func,
  customTickLottie: PropTypes.object,
  isVoucherTopUpContainer: PropTypes.bool,
};

export default withTheme(PaymentCenterView);
